import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, notification, Form, Space,Tooltip, Modal,Input } from "antd";
import GenericTable from "../components/GenericTable";
import GenericDrawer from "../components/GenericModal"; // Corrected from GenericModal to GenericDrawer
import GenericViewModal from "../components/GenericViewModal";
import {
  fetchVisitsRequest,
  createVisitRequest,
  updateVisitRequest,
  deleteVisitRequest,
} from "../redux-saga/actions/visitActions";
import { fetchPatientsRequest }from "../redux-saga/actions/patientActions";
import { useParams } from "react-router-dom";
import ProjectNavbar from "../components/ProjectNavbar";
import { updateCurrentProjectId } from "../redux-saga/actions/customerActions";
import moment from "moment";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import {IconCalendarEvent} from '@tabler/icons-react';


const VisitPage = () => {
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const visits = useSelector((state) => state.visit.visits?.data);
  const loading = useSelector((state) => state.visit.loading);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingVisit, setEditingVisit] = useState(null);
  const [form] = Form.useForm();
  const [viewingVisit, setViewingVisit] = useState(null);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const patients = useSelector((state) => state.patient.patients?.data);

  const metaData = useSelector((state) => state.visit.visits?.meta || {});
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  
  const visitModalInputs = [
    { label: "Visit Number", name: "visitNumber", type: "number" },
    { label: "MRN", name: "mrn", type: "text" },
    { label: "Patient ID", name: "patientId", type: "select", options: Array.isArray(patients)
      ? patients.map((patient) => ({
          label: patient.name,
          value: patient.id,
        }))
      : [],  },
  ];

  useEffect(() => {
    if (projectId) {
      dispatch(fetchVisitsRequest(projectId,{ page: currentPage, limit: 2, search: searchTerm }));
      dispatch(updateCurrentProjectId(projectId));
      dispatch(fetchPatientsRequest(projectId));
    }
  }, [dispatch, projectId,currentPage, searchTerm]);

  const handleCreateOrEdit = async (values) => {
    const payload = {
      visitNumber: Number(values.visitNumber),  // Ensure visitNumber is a number
      mrn: values.mrn,                          // mrn should be a string
      patientId: values.patientId,              // patientId should be a string
    };
  
    try {
      if (editingVisit) {
        await dispatch(updateVisitRequest(editingVisit.id, payload, projectId));
      } else {
        await dispatch(createVisitRequest({ ...payload, projectId }));
      }
      notification.success({
        message: "Success",
        description: "Visit saved successfully.",
      });
      setIsModalVisible(false);
      setEditingVisit(null);
      form.resetFields();
    } catch (error) {
      if (error.response && error.response.status === 409) {
        notification.error({
          message: "Conflict",
          description: "Visit with the same Visit Number and MRN already exists.",
        });
      } else {
        notification.error({
          message: "Error",
          description: "An unexpected error occurred. Please try again.",
        });
      }
    }
  };
  
  

  const handleView = (record) => {
    const formattedRecord = {
      ...record,
      createdAt: record.createdAt ? moment(record.createdAt).format("YYYY-MM-DD HH:mm:ss") : null,
      updatedAt: record.updatedAt ? moment(record.updatedAt).format("YYYY-MM-DD HH:mm:ss") : null,
    };
    setViewingVisit(formattedRecord);
    setIsViewModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingVisit(record);
    setIsModalVisible(true);
    form.setFieldsValue(record);
  };

  const handleDelete = (record) => {
   Modal.confirm({
      title: "Are you sure you want to delete this visit?",
      onOk: async () => {
        try {
           dispatch(deleteVisitRequest(record.id, projectId));
          notification.success({
            message: "Success",
            description: "Visit deleted successfully.",
          });
        } catch (error) {
          notification.error({
            message: "Error",
            description: "An unexpected error occurred. Please try again.",
          });
        }
      },
    });
  };

  const columnsConfig = [
    { title: "Visit Number", dataIndex: "visitNumber" },
    { title: "MRN", dataIndex: "mrn" },
    // { title: "Patient ID", dataIndex: "patientId" },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="View">
            <EyeOutlined style={{ fontSize: "20px", color: "#1890ff" }} onClick={() => handleView(record)} />
          </Tooltip>
          <Tooltip title="Edit">
            <EditOutlined style={{ fontSize: "20px", color: "#faad14" }} onClick={() => handleEdit(record)} />
          </Tooltip>
          <Tooltip title="Delete">
            <DeleteOutlined style={{ fontSize: "20px", color: "#f5222d" }} onClick={() => handleDelete(record)} />
          </Tooltip>
        </Space>
      ),
    },
  ];
  
 

  return (
    <div style={{ display: "flex", gap: "10px" }}>
      <ProjectNavbar />
      <div style={{ width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
              <IconCalendarEvent style={{ fontSize: "24px", color: "black" }} />
                <h2 style={{ margin: 0 }}>Visit</h2>
            </div>

            <div style={{ display: "flex", justifyContent: "end", marginBottom: 11 }}>
              <Button type="primary" onClick={() => setIsModalVisible(true)}>
                Create Visit
              </Button>
            </div>
        </div>
        <Input
          placeholder="Search Visit"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: "16px" }}
        />
        <GenericTable data={visits} columnsConfig={columnsConfig} loading={loading}
        pagination={{
          current: metaData.page || 1,
          pageSize: metaData.limit || 2,
          total: metaData.total || 0,
          onChange: (page, pageSize) => {
            setCurrentPage(page);
            dispatch(fetchVisitsRequest({ page, limit: pageSize, search: searchTerm }));
          },
        }}  />
        {isModalVisible && (
          <GenericDrawer
            isVisible={isModalVisible}
            handleCancel={() => {
              setIsModalVisible(false);
              setEditingVisit(null);
            }}
            title={
              <span style={{display : "flex",alignItems:"center"}}>
                <IconCalendarEvent style={{ color: "white", marginRight: "8px" }} />
                {editingVisit ? "Edit Visit" : "Create Visit"}
              </span>
            }
            inputs={visitModalInputs}
            onSubmit={handleCreateOrEdit}
            predefinedData={editingVisit || {}}
          />
        )}
        {isViewModalVisible && (
          <GenericViewModal
            isVisible={isViewModalVisible}
            handleCancel={() => setIsViewModalVisible(false)}
            title="View Visit"
            data={viewingVisit}
            footerButtons={["Close"]}
            onButtonClick={() => setIsViewModalVisible(false)}
          />
        )}
      </div>
    </div>
  );
};

export default VisitPage;
